module.exports = __webpack_public_path__ + "assets/img/new.29f51d59.png";